import { useEffect } from "react";
import { useLocation } from "react-router";
import { usePrevious } from "../constants/constants";
// Based on react-router docs to ensure that window scoll
// is reset on every router transition.
// https://reacttraining.com/react-router/web/guides/scroll-restoration/scroll-to-top
const ScrollToTop = ({ children }) => {
  const location = useLocation();
  const prevLocation = usePrevious(location);
  useEffect(() => {
    if (prevLocation && prevLocation !== location) {
      window.scrollTo(0, 0);
    }
  });
  return children;
};

export default ScrollToTop;
